import { StateCreator } from 'zustand';

import { TSubscriptionStore } from './types';

export const subscriptionsSlice: StateCreator<TSubscriptionStore, [], [], TSubscriptionStore> = (set) => ({
  subscriptionInfo: null,
  setSubscriptionInfo: (subscriptionInfo) => set({ subscriptionInfo }),
});
